var $resultTable = null;
var $sortLabels = null;

$(document).ready(function() {
	$resultTable = $('#link-table div.item');
	$sortLabels = $(".sortselect");
	
	$( document ).trigger( "hotel_filter_event");
	
	hotelSearchFilter.init();
	hotelSortFilter.init();
	// mobile filter toggle
	$( ".btn-filter" ).click(function() {
		$( "#collapseFilter" ).toggleClass( "d-none d-md-flex position-fixed top-0 start-0 bottom-0 end-0 z-3 p-2 overflow-auto bg-white" );
		$( "#collapseFilter .accordion-body" ).toggleClass( "bg-light" );
		$( ".close-text" ).toggleClass( "d-none" );
	});
	$( "#btn-change-search" ).click(function() {
	  $( ".search-bg" ).toggleClass( "d-none d-md-block" );
	});
});

var hotelSearchFilter = function() {
	var $nameFilter = $("#filterByName");
	var $stars = $(".filterByStar");
	var $boards = $(".filterByBoard");
	
	this.init = function (){
		$("#filterByName").keyup(function() {
			applyFilter();
		});
		
		$(".filterByStar").click(function() {
			applyFilter();
			$('.btnResetFilter').removeClass('opacity-0');
		});

		$(".filterByBoard").click(function() {
			applyFilter();
			$('.btnResetFilter').removeClass('opacity-0');
		});
		
		if($resultTable != null){
			var minPrice = $($resultTable.first()).attr("price");
			var maxPrice = $($resultTable.last()).attr("price");
			var minSliderValue = parseInt(minPrice / 10, 10) * 10;
			var maxSliderValue = parseInt(maxPrice / 10, 10) * 10 + 10;
			
			$('#minPrice').val(minSliderValue);
			$('#minPrice').attr('min',minSliderValue);
			$('#minPrice').attr('max',maxSliderValue);
			$('#maxPrice').val(maxSliderValue);
			$('#maxPrice').attr('min',minSliderValue);
			$('#maxPrice').attr('max',maxSliderValue);
			
			$("#minPrice, #maxPrice").on('change',function(){
				applyFilter();
				$('.btnResetFilter').removeClass('opacity-0');
			});
		}
		
		$(".btnResetFilter").click(function() {
			$('#minPrice').val($('#minPrice').attr('min'));
			$('#maxPrice').val($('#maxPrice').attr('max'));
			$('.filterByStar').prop("checked", true);
			$('.filterByBoard').prop("checked", true);
			$(this).addClass('opacity-0');
			applyFilter();
		});
	}
	
	this.applyFilter = function() {
		var filter = getFilter();
		$resultTable.each(function(index, item){
			var show = isMatchesFilter(item, filter);
			if(show){
				$(item).show();
			}
			else{
				$(item).hide();
			}
		});
	}
	
	var getFilter = function(){
		var stars = {}
		$stars.each(function(index, item){
			stars[item.value] = $(item).prop("checked");
		});

		var boards = {}
		$boards.each(function(index, item){
			boards[item.value] = $(item).prop("checked");
		});
		
		return {
			minprice : parseInt($("#minPrice").val()),
			maxprice : parseInt($("#maxPrice").val()),
			name : $nameFilter.val().toLocaleLowerCase("tr-TR"),
			stars : stars,
			boards : boards
		}
	}
	
	function _fnEscapeRegex ( sVal ) {
		var letters = { "İ": "[İi]", "I": "[İi]", "Ş": "[Şş]", "Ğ": "[Ğğ]", "Ü": "[Üü]", "Ö": "[Öö]", "Ç": "[Çç]", "i": "[İi]", "ı": "[İi]", "ş": "[Şş]", "ğ": "[Ğğ]", "ü": "[Üü]", "ö": "[Öö]", "ç": "[Çç]" };
		return sVal.replace(/(([İIŞĞÜÇÖiışğüçö]))/g, function (letter) { return letters[letter]; });
	}

	var isMatchesFilter = function(item, filter){
		if(filter.name.length > 0){
			var _name = _fnEscapeRegex(filter.name);
			var itemName = _fnEscapeRegex($(item).attr("hotelname").toLocaleLowerCase("tr-TR"));

			if(itemName.indexOf(_name) < 0){		
				return false;
			}
		} 
		
		if($(item).attr("star") in filter.stars && !filter.stars[$(item).attr("star")]){
			return false;
		}
		
		var boardlistItems = $(item).attr("boardlist");
		if(boardlistItems){
			var propertyList = boardlistItems.split(",");
			for(var pIndex in propertyList){
				if(propertyList[pIndex] in filter.boards && !filter.boards[propertyList[pIndex]]){
					return false;
				}
			}
		} else {
			return false;
		}
		
		if(filter.minprice > $(item).attr("price") || filter.maxprice < $(item).attr("price")) {
			return false;
		}
		
		return true;
	}
	
	return {
		init : init
	}
}();

var hotelSortFilter = function() {

	this.init = function (){
		
		$sortLabels.on('change', function(event){
	
			$(".sortselect.bg-light").not(this)
				.removeClass("bg-light").removeClass("desc");
			
			$("select.sortselect").not(this).val(0);
			
			var $this = $(this);
			var $option = $this.find(":selected");
			var attribute = $option.attr("data-filter-attribute");
			var direction = $option.attr("data-filter-direction");
			
			$this.addClass("bg-light");
			if (direction == 'desc') {
				$this.addClass("dec");
			}else{
				$this.removeClass("dec");
			}
			var valueType = $option.attr("data-filter-value-type");
			var hotelSortFunction = function(a, b) {
				var result;
				var valueA = $(a).attr(attribute);
				var valueB = $(b).attr(attribute);

				if (valueType == 'numeric') {
					valueA = parseFloat(valueA);
					valueB = parseFloat(valueB);
				}
				//To handle NaN score values
				if(!valueA){
					valueA = -1;
				}
				if(!valueB){
					valueB = -1;
				}
				//
				result = (valueA < valueB) ? -1 : (valueA > valueB) ? 1 : 0;
				if (direction == 'desc') {
					result *= -1;
				}
				return result;
			};

			$resultTable.sort(hotelSortFunction).appendTo("#hotelResultTable");

			$( document ).trigger( "hotel_filter_event");

		});
		
		// SORT BY RECOMENDED
		var sortbyRecomended = function(a, b) {
			var result;
			var valueA = $(a).attr('recomended') == 'true' ? 0 : 1;
			var valueB = $(b).attr('recomended') == 'true' ? 0 : 1;

			result = (valueA < valueB) ? -1 : (valueA > valueB) ? 1 : 0;

			return result;
		};
		$resultTable.sort(sortbyRecomended).appendTo("#hotelResultTable");
	}

	return {
		init : init
	}
	
}();